import { useContext, useEffect, useState } from "react";
import { AiFillFileText, AiOutlineSetting } from "react-icons/ai";
import {
  BsCalendar3,
  BsCalendarCheckFill,
  BsFileEarmarkPersonFill,
  BsFileTextFill,
  BsFillGrid1X2Fill,
  BsPersonFillGear,
  BsTools,
} from "react-icons/bs";
import {
  FaBusinessTime,
  FaCheckSquare,
  FaClipboardList,
  FaSitemap,
  FaUserShield,
  FaUsers,
} from "react-icons/fa";
import { FaHouseLock, FaIdCard } from "react-icons/fa6";
import { GiOpenBook, GiTalk } from "react-icons/gi";
import { HiChip, HiOutlineDocumentText } from "react-icons/hi";
import { ImUserTie, ImUsers } from "react-icons/im";
import { IoMdSettings } from "react-icons/io";
import {
  MdEmail,
  MdManageAccounts,
  MdOutlineSchedule,
  MdWifiCalling,
} from "react-icons/md";
import { RiLockPasswordFill, RiShieldUserLine } from "react-icons/ri";
import { SiCrowdsource } from "react-icons/si";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  authorizationConstant,
  tourGroups,
} from "../../common/utils/CommonConstants";
import { useTour } from "../../common/utils/TourContext";
import { UserContext } from "../layout/layout";
import "./sidebar.scss";

function SidebarComponent() {
  const { user, setUser }: any = useContext(UserContext);
  const [paths, setPaths] = useState<Array<string>>([]);
  const location = useLocation();
  let PageRouteArray = location.pathname.split("/");
  const navigate = useNavigate();

  const [active, setactiveComponent] = useState("");
  const { registerGroupHandlers } = useTour();
  const [menuOpenStates, setMenuOpenStates] = useState<Record<string, boolean>>(
    {}
  );
  const [sidebarId, setSidebarId] = useState("");

  useEffect(() => {
    const index = paths?.findIndex(
      (item) =>
        item.toLowerCase().replace(/\s/g, "") ===
          PageRouteArray[1].toLowerCase() && PageRouteArray?.length >= 1
    );
    index >= 0 && setactiveComponent(paths[index]);
  }, [PageRouteArray]);

  useEffect(() => {
    if (location.pathname === "/login") {
      setPaths([]);
    } else {
      setPaths(user?.access);
    }
  }, []);

  useEffect(() => {
    tourGroups.forEach((group) => {
      registerGroupHandlers(
        group,
        () => {
          openMenuById(group);
          return Promise.resolve();
        },
        () => {
          closeMenuById(group);
          return Promise.resolve();
        }
      );
    });
  }, []);

  const openMenuById = (id: string) => {
    setMenuOpenStates((prev) => ({ ...prev, [id]: true }));
  };

  const closeMenuById = (id: string) => {
    setMenuOpenStates((prev) => ({ ...prev, [id]: false }));
  };
  return (
    <div className="sidebar" style={{ display: "flex", height: "100%" }}>
      <Sidebar breakPoint="md">
        <div className="logoblk">
          <span className="logo"></span>
        </div>
        {paths && paths?.length > 0 && (
          <Menu>
            {paths?.includes("Dashboard") && (
              <MenuItem
                id="Dashboard"
                onClick={() => {
                  navigate("/dashboard");
                  setactiveComponent("Dashboard");
                }}
                className="menu-item menu-dashboard"
              >
                <BsFillGrid1X2Fill
                  className={`menu-icon ${active === "Dashboard" && "active"}`}
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                />{" "}
                <span
                  className={`menu-text ${active === "Dashboard" && "active"}`}
                >
                  {" "}
                  Dashboard
                </span>
              </MenuItem>
            )}

            {paths?.includes("My Interview") && (
              <MenuItem
                id="MyInterview"
                className="menu-interview"
                onClick={() => {
                  navigate("/myInterview");
                  setactiveComponent("My Interview");
                }}
              >
                <GiTalk
                  className={`menu-icon ${
                    active === "My Interview" && "active"
                  }`}
                  size={24}
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                />{" "}
                <span
                  className={`menu-text ${
                    active === "My Interview" && "active"
                  }`}
                >
                  {" "}
                  My Interview
                </span>
              </MenuItem>
            )}

            {paths?.includes("Manage Request") && (
              <MenuItem
                id="ManageRequest"
                onClick={() => {
                  setactiveComponent("Manage Request");
                }}
                component={<Link to="/manageRequest" />}
              >
                <BsCalendarCheckFill
                  className={`menu-icon ${
                    active === "Manage Request" && "active"
                  }`}
                />
                <span
                  className={`menu-icon ${
                    active === "Manage Request" && "active"
                  }`}
                >
                  {" "}
                  Manage Request
                </span>
              </MenuItem>
            )}

            {paths.includes("Resume Screening") && (
              <SubMenu
                id="ResumeScreening"
                onClick={() => {
                  setactiveComponent("ResumeScreening");
                  setMenuOpenStates({});
                }}
                open={menuOpenStates["ResumeScreening"]}
                className="conf-menu"
                label={
                  <label
                    className={`menu-icon ${
                      active === "SmartResumeParser" && "active"
                    }`}
                  >
                   Resume Screening
                  </label>
                }
                icon={
                  <BsFileEarmarkPersonFill
                    className={`menu-icon ${
                      active === "SmartResumeParser" && "active"
                    }`}
                  />
                }
              >
                <MenuItem
                  id="SmartResumeParser"
                  onClick={() => {
                    setactiveComponent("Smart Resume Parser");
                  }}
                  component={<Link to="/SmartResumeParser" />}
                >
                  <AiFillFileText
                    className={`menu-icon ${
                      active === "Smart Resume Parser" && "active"
                    }`}
                  />
                  <span
                    className={`menu-icon ${
                      active === "Smart Resume Parser" && "active"
                    }`}
                  >
                  Smart Resume Parser
                  </span>
                </MenuItem>

                <MenuItem
                  id="ResumeDashboard"
                  onClick={() => {
                    setactiveComponent("Resume Dashboard");
                  }}
                  component={<Link to="/resumeDashboard" />}
                >
                  <FaCheckSquare
                    className={`menu-icon ${
                      active === "Resume Dashboard" && "active"
                    }`}
                  />
                  <span
                    className={`menu-icon ${
                      active === "Resume Dashboard" && "active"
                    }`}
                  >
                   Resume Dashboard
                  </span>
                </MenuItem>
              </SubMenu>
            )}

            {authorizationConstant.resourcePageList.some((item) =>
              paths.includes(item)
            ) && (
              <SubMenu
                id="resourceManagement"
                onClick={() => {
                  setactiveComponent("resourceManagement");
                  setMenuOpenStates({});
                }}
                open={menuOpenStates["resourceManagement"]}
                className="conf-menu"
                label={
                  <label
                    className={`menu-icon ${
                      active === "resourceManagement" && "active"
                    }`}
                  >
                    Resource Management
                  </label>
                }
                icon={
                  <FaSitemap
                    className={`menu-icon ${
                      active === "Candidate Management" && "active"
                    }`}
                  />
                }
              >
                {paths.includes("Manage User") && (
                  <MenuItem
                    id="ManageUser"
                    onClick={() => {
                      setactiveComponent("Manage User");
                    }}
                    component={<Link to="/manageUser" />}
                  >
                    <ImUsers
                      className={`menu-icon ${
                        active === "Manage User" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage User" && "active"
                      }`}
                    >
                      Manage User
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Interview Panel") && (
                  <MenuItem
                    id="InterviewPanel"
                    onClick={() => {
                      setactiveComponent("Interview Panel");
                    }}
                    component={<Link to="/interviewPanel" />}
                  >
                    <FaUsers
                      size={20}
                      className={`menu-icon ${
                        active === "Interview Panel" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Interview Panel" && "active"
                      }`}
                    >
                      Interview Panel
                    </span>
                  </MenuItem>
                )}
              </SubMenu>
            )}

            {authorizationConstant.candidatePageList.some((item) =>
              paths.includes(item)
            ) && (
              <SubMenu
                id="candidateManagement"
                onClick={() => {
                  setactiveComponent("Candidate Management");
                  setMenuOpenStates({});
                }}
                open={menuOpenStates["candidateManagement"]}
                className="conf-menu"
                label={
                  <label
                    className={`menu-icon ${
                      active === "Candidate Management" && "active"
                    }`}
                  >
                    Candidate Management
                  </label>
                }
                icon={
                  <MdManageAccounts
                    className={`menu-icon ${
                      active === "Candidate Management" && "active"
                    }`}
                  />
                }
              >
                {paths.includes("Calling Candidate") && (
                  <MenuItem
                    id="CallingCandidate"
                    onClick={() => {
                      setactiveComponent("Calling Candidate");
                    }}
                    component={<Link to="/callingCandidate" />}
                  >
                    <MdWifiCalling
                      className={`menu-icon ${
                        active === "Calling Candidate" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Calling Candidate" && "active"
                      }`}
                    >
                      Calling Candidate
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Manage Candidate") && (
                  <MenuItem
                    id="ManageCandidate"
                    onClick={() => {
                      setactiveComponent("Manage Candidate");
                    }}
                    component={<Link to="/manageCandidate" />}
                  >
                    <ImUserTie
                      className={`menu-icon ${
                        active === "Manage Candidate" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage Candidate" && "active"
                      }`}
                    >
                      Manage Candidate
                    </span>
                  </MenuItem>
                )}
              </SubMenu>
            )}

            {authorizationConstant.rolePageList.some((item) =>
              paths.includes(item)
            ) && (
              <SubMenu
                id="roleManagement"
                onClick={() => {
                  setactiveComponent("Role Management");
                  setMenuOpenStates({});
                }}
                open={menuOpenStates["roleManagement"]}
                className="conf-menu"
                label={
                  <label
                    className={`menu-icon ${
                      active === "Role Management" && "active"
                    }`}
                  >
                    Role Management
                  </label>
                }
                icon={
                  <FaUserShield
                    className={`menu-icon ${
                      active === "Role Management" && "active"
                    }`}
                  />
                }
              >
                {paths?.includes("Manage Role") && (
                  <MenuItem
                    id="ManageRole"
                    onClick={() => {
                      setactiveComponent("Manage Role");
                    }}
                    component={<Link to="/manageRole" />}
                  >
                    <FaBusinessTime
                      size={20}
                      className={`menu-icon ${
                        active === "Manage Role" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage Role" && "active"
                      }`}
                    >
                      Manage Role
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Role Activity") && (
                  <MenuItem
                    id="RoleActivity"
                    onClick={() => {
                      setactiveComponent("Role Activity");
                    }}
                    component={<Link to="/roleActivity" />}
                  >
                    <BsPersonFillGear
                      size={20}
                      className={`menu-icon ${
                        active === "Role Activity" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Role Activity" && "active"
                      }`}
                    >
                      Role Activity
                    </span>
                  </MenuItem>
                )}
              </SubMenu>
            )}

            {authorizationConstant.masterPageList.some((item) =>
              paths.includes(item)
            ) && (
              <SubMenu
                id="masterData"
                onClick={() => {
                  setactiveComponent("Master Data");
                  setMenuOpenStates({});
                }}
                open={menuOpenStates["masterData"]}
                className="conf-menu"
                label={
                  <label
                    className={`menu-icon ${
                      active === "Master Data" && "active"
                    }`}
                  >
                    Master Data
                  </label>
                }
                icon={
                  <IoMdSettings
                    className={`menu-icon ${
                      active === "Master Data" && "active"
                    }`}
                  />
                }
              >
                {paths.includes("JD Template") && (
                  <MenuItem
                    id="JDTemplate"
                    onClick={() => {
                      setactiveComponent("JD Template");
                    }}
                    component={<Link to="/jdTemplate" />}
                  >
                    <FaClipboardList
                      size={20}
                      className={`menu-icon ${
                        active === "JD Template" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "JD Template" && "active"
                      }`}
                    >
                      JD Template
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Manage Lead Time") && (
                  <MenuItem
                    id="ManageLeadTime"
                    onClick={() => {
                      setactiveComponent("Manage Lead Time");
                    }}
                    component={<Link to="/manageLeadTime" />}
                  >
                    <BsCalendar3
                      size={18}
                      className={`menu-icon ${
                        active === "Manage Lead Time" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage Lead Time" && "active"
                      }`}
                    >
                      Manage Lead Time
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Manage Technology") && (
                  <MenuItem
                    id="ManageTechnology"
                    onClick={() => {
                      setactiveComponent("Manage Technology");
                    }}
                    component={<Link to="/manageTechnology" />}
                  >
                    <HiChip
                      size={22}
                      className={`menu-icon ${
                        active === "Manage Technology" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage Technology" && "active"
                      }`}
                    >
                      Manage Technology
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Manage Skill") && (
                  <MenuItem
                    id="ManageSkill"
                    onClick={() => {
                      setactiveComponent("Manage Skill");
                    }}
                    component={<Link to="/manageSkill" />}
                  >
                    <BsTools
                      className={`menu-icon ${
                        active === "Manage Skill" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage Skill" && "active"
                      }`}
                    >
                      Manage Skill
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Manage Project") && (
                  <MenuItem
                    id="ManageProject"
                    onClick={() => {
                      setactiveComponent("Manage Project");
                    }}
                    component={<Link to="/manageProject" />}
                  >
                    <FaBusinessTime
                      size={20}
                      className={`menu-icon ${
                        active === "Manage Project" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage Project" && "active"
                      }`}
                    >
                      Manage Project
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Manage Designation") && (
                  <MenuItem
                    id="ManageDesignation"
                    onClick={() => {
                      setactiveComponent("Manage Designation");
                    }}
                    component={<Link to="/manageDesignation" />}
                  >
                    <FaIdCard
                      size={20}
                      className={`menu-icon ${
                        active === "Manage Designation" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage Designation" && "active"
                      }`}
                    >
                      Manage Designation
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Manage Education") && (
                  <MenuItem
                    id="ManageEducation"
                    onClick={() => {
                      setactiveComponent("Manage Education");
                    }}
                    component={<Link to="/manageEducation" />}
                  >
                    <GiOpenBook
                      className={`menu-icon ${
                        active === "Manage Education" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage Education" && "active"
                      }`}
                    >
                      Manage Education
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Manage Sources") && (
                  <MenuItem
                    id="ManageSources"
                    onClick={() => {
                      setactiveComponent("Manage Sources");
                    }}
                    component={<Link to="/manageSources" />}
                  >
                    <SiCrowdsource
                      size={20}
                      className={`menu-icon ${
                        active === "Manage Sources" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Manage Sources" && "active"
                      }`}
                    >
                      Manage Sources
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Letter Configuration") && (
                  <MenuItem
                    id="LetterConfiguration"
                    onClick={() => {
                      setactiveComponent("Letter Configuration");
                    }}
                    component={<Link to="/letterConfiguration" />}
                  >
                    <HiOutlineDocumentText
                      size={22}
                      className={`menu-icon ${
                        active === "Letter Configuration" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Letter Configuration" && "active"
                      }`}
                    >
                      Letter Configuration
                    </span>
                  </MenuItem>
                )}
              </SubMenu>
            )}

            {authorizationConstant.accessPageList.some((item) =>
              paths.includes(item)
            ) && (
              <SubMenu
                id="accessManagement"
                onClick={() => {
                  setactiveComponent("Access Management");
                  setMenuOpenStates({});
                }}
                open={menuOpenStates["accessManagement"]}
                className="conf-menu"
                label={
                  <label
                    className={`menu-icon ${
                      active === "Access Management" && "active"
                    }`}
                  >
                    Access Management
                  </label>
                }
                icon={
                  <RiShieldUserLine
                    className={`menu-icon ${
                      active === "Access Management" && "active"
                    }`}
                  />
                }
              >
                {paths.includes("Platform Integrations") && (
                  <MenuItem
                    id="PlatformIntegrations"
                    onClick={() => {
                      setactiveComponent("Platform Integrations");
                    }}
                    component={<Link to="/platformIntegrations" />}
                  >
                    <FaHouseLock
                      size={20}
                      className={`menu-icon ${
                        active === "Platform Integrations" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Platform Integrations" && "active"
                      }`}
                    >
                      Platform Integrations
                    </span>
                  </MenuItem>
                )}
                {paths.includes("Auth Configuration") && (
                  <MenuItem
                    id="AuthConfiguration"
                    onClick={() => {
                      setactiveComponent("Auth Configuration");
                    }}
                    component={<Link to="/authConfiguration" />}
                  >
                    <RiLockPasswordFill
                      size={20}
                      className={`menu-icon ${
                        active === "Auth Configuration" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Auth Configuration" && "active"
                      }`}
                    >
                      Auth Configuration
                    </span>
                  </MenuItem>
                )}
              </SubMenu>
            )}

            {authorizationConstant.systemConfigurationPageList.some((item) =>
              paths.includes(item)
            ) && (
              <SubMenu
                id="systemConfiguration"
                onClick={() => {
                  setactiveComponent("systemConfiguration");
                  setMenuOpenStates({});
                }}
                open={menuOpenStates["systemConfiguration"]}
                className="conf-menu"
                label={
                  <label
                    className={`menu-icon ${
                      active === "systemConfiguration" && "active"
                    }`}
                  >
                    System Configuration
                  </label>
                }
                icon={
                  <AiOutlineSetting
                    className={`menu-icon ${
                      active === "systemConfiguration" && "active"
                    }`}
                  />
                }
              >
                {paths.includes("Email Configuration") && (
                  <MenuItem
                    id="EmailConfiguration"
                    onClick={() => {
                      setactiveComponent("Email Configuration");
                    }}
                    component={<Link to="/emailConfiguration" />}
                  >
                    <MdEmail
                      size={22}
                      className={`menu-icon ${
                        active === "Email Configuration" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Email Configuration" && "active"
                      }`}
                    >
                      Email Configuration
                    </span>
                  </MenuItem>
                )}

                {paths.includes("Cron Configuration") && (
                  <MenuItem
                    id="CronConfiguration"
                    onClick={() => {
                      setactiveComponent("Cron Configuration");
                    }}
                    component={<Link to="/cronConfiguration" />}
                  >
                    <MdOutlineSchedule
                      size={20}
                      className={`menu-icon ${
                        active === "Cron Configuration" && "active"
                      }`}
                    />
                    <span
                      className={`menu-icon ${
                        active === "Cron Configuration" && "active"
                      }`}
                    >
                      Cron Configuration
                    </span>
                  </MenuItem>
                )}

              </SubMenu>
            )}

            {paths.includes("Reports") && (
              <MenuItem
                id="Reports"
                onClick={() => {
                  setactiveComponent("Reports");
                }}
                component={<Link to="/reports" />}
              >
                <BsFileTextFill
                  className={`menu-icon ${active === "Reports" && "active"}`}
                />
                <span
                  className={`menu-icon ${active === "Reports" && "active"}`}
                >
                  {" "}
                  Reports
                </span>
              </MenuItem>
            )}
          </Menu>
        )}
      </Sidebar>
    </div>
  );
}

export default SidebarComponent;
